import React from 'react';
import theme from 'src/styles/theme';
import styled from 'styled-components';

export enum BadgeVariantsType {
    RED = 'red',
    ORANGE = 'orange',
    GREEN = 'green',
    YELLOW = 'yellow',
    DEFAULT = 'default',
    LIGHT = 'light',
    DARK = 'dark',
}

export enum BadgeSizeVariantsType {
    LARGE = 'large',
    DEFAULT = 'default',
    SMALL = 'small',
}

interface IProps {
    text?: string;
    variant: BadgeVariantsType;
    size?: BadgeSizeVariantsType;
    styles?: {};
    margin?: string;
    onClick?: (e: any) => void;
    classNames?: string;
}

const styles = {
    red: {
        backgroundColor: theme.colors.v2.light.englishVermillion.default,
        color: theme.colors.v2.light.grayscale.white,
    },
    orange: {
        backgroundColor: theme.colors.v2.light.yellow.default,
        color: theme.colors.v2.light.yellow[60],
    },
    green: {
        backgroundColor: theme.colors.v2.light.green.default,
        color: theme.colors.v2.light.grayscale.white,
    },
    yellow: {
        backgroundColor: theme.colors.v2.light.yellow.default,
        color: theme.colors.v2.light.yellow[60],
    },
    default: {
        backgroundColor: theme.colors.v2.light.darkCyan.default,
        color: theme.colors.v2.light.grayscale.white,
    },
    light: {
        backgroundColor: theme.colors.v2.light.grayscale.white,
        color: theme.colors.v2.light.grayscale.default,
        border: '1px solid #DFDFDF',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.06)',
    },
    dark: {
        backgroundColor: theme.colors.v2.light.grayscale.default,
        color: theme.colors.v2.light.grayscale.white,
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.06)',
    },
};

const BadgeWrapper = styled.div<Partial<IProps>>`
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ce4a4c;
    border-radius: 100px;
    padding: ${(props) =>
        props.size
            ? props.size === BadgeSizeVariantsType.SMALL
                ? '2px 6px'
                : props.size === BadgeSizeVariantsType.LARGE
                ? '4px 12px'
                : '2px 8px'
            : '2px 8px'};
    width: max-content;
    font-weight: 600;
    cursor: default;
`;

const Badge = (props: IProps) => {
    return (
        <BadgeWrapper
            style={{
                ...styles[props.variant],
                margin: props.margin,
                fontSize: props.size ? (props.size === BadgeSizeVariantsType.SMALL ? '12px' : '14px') : '14px',
                padding: props.size
                    ? props.size === BadgeSizeVariantsType.SMALL
                        ? '2px 6px'
                        : props.size === BadgeSizeVariantsType.LARGE
                        ? '4px 12px'
                        : '2px 8px'
                    : '2px 8px',
            }}
        >
            {props.text}
        </BadgeWrapper>
    );
};

Badge.defaultProps = {
    text: '1',
    variant: BadgeVariantsType.DEFAULT,
    size: BadgeSizeVariantsType.DEFAULT,
    styles: {},
} as Partial<IProps>;

export default Badge;
